

















































































import ToolsHelper from '@core/services/tools.helper';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BpcPosPaymentBalanceDetails from './pos-payment-balance-details.vue';
@Component({
  name: 'bpc-pos-keyboard-v2',
  components: {
    BpcPosPaymentBalanceDetails,
  },
})
export default class PosKeyboardV2 extends Vue {
  @Prop({
    type: Number,
    required: true,
  })
  readonly amountToBePaid!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  readonly value!: number;

  get model(): number {
    return this.value;
  }

  set model(value: number) {
    this.$emit('input', value);
  }

  disableAddButton() {
    return false;
  }

  disableCommaButton() {
    return false;
  }

  clear() {
    this.model = 0;
    this.modelStr = '';
  }

  modelStr = '';

  add(numberStr: string) {
    // Prevent more than 2 decimal digits
    const currentDecimalDigits = this.modelStr.split('.')[1];
    const numberOfDecimalDigits = currentDecimalDigits ? currentDecimalDigits.length : 0;
    if (numberOfDecimalDigits >= 2) return;

    // Append the digit properly
    if (this.modelStr === '0') {
      // If current value is "0" and user presses a number, replace it (but not if there’s a decimal)
      this.modelStr = numberStr;
    } else {
      this.modelStr += numberStr;
    }

    // Only parse if it's a valid number (e.g., avoid NaN for "0.")
    const parsed = parseFloat(this.modelStr);
    this.model = isNaN(parsed) ? 0 : parsed;

    console.log('this.modelStr', this.modelStr);
  }

  addDecimal() {
    if (!this.modelStr) {
      // Start with "0." if empty
      this.modelStr = '0.';
    } else if (!this.modelStr.includes('.')) {
      this.modelStr += '.';
    }

    // Do not force parseFloat here; "0." is valid as intermediate input
    const parsed = parseFloat(this.modelStr);
    this.model = isNaN(parsed) ? 0 : parsed;

    console.log('this.modelStr', this.modelStr);
  }

  deleteLastCharacter() {
    if (this.modelStr.length <= 1) {
      this.modelStr = '';
      this.model = 0;
    } else {
      this.modelStr = this.modelStr.slice(0, -1);
      this.model = parseFloat(this.modelStr);
    }
  }

  toggleSign() {
    const modelValue = this.model;
    this.model = -modelValue;
    this.modelStr = `${-modelValue}`;
    console.log('this.modelStr', this.modelStr);
  }

  get disabled() {
    return false; // TODO make it a prop
  }
}
